:host {
  border: 1px solid var(--color-monochromatic);
  background-color: var(--color-white);
  width: 100%;
  padding: 24px 16px;
  display: grid;
  grid-template-columns: 24px auto;
  gap: 8px;
  position: relative;
  border-radius: 2px;
}

:host(.disabled) {
  background-color: #fbfbfb;
}

:host(.active) {
  border-color: var(--color-nero);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
}

:host(.arrow) {
  grid-template-columns: 24px auto 7px;
}

.flag {
  color: var(--color-white);
  position: absolute;
  top: -10px;
  left: -8px;
  padding-left: 8px;
  padding-right: 20px;
  z-index: 0;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: end;
  overflow: hidden;

  &:before,
  &:after {
    z-index: -1;
    background-color: var(--color-nero);
    transform-origin: top right;
    transform: skewX(-45deg);
    position: absolute;
    content: '';
    left: -45px;
    height: 100%;
    right: 0;
    top: 0;
  }

  &:after {
    transform-origin: bottom right;
    transform: skewX(45deg);
    top: auto;
    bottom: 0;
  }

  lilu-p {
    height: 18px;
  }
}

.head {
  display: grid;
  grid-template-columns: auto 1fr auto;

  ::slotted(lilu-icon) {
    padding-right: 8px;
  }

  ::slotted(lilu-p) {
    max-height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.tooltip {
  display: flex;
  margin-left: auto;
  padding-left: 8px;

  ::slotted(lilu-p) {
    margin-top: 4px;
    @include breakpointMin('lg') {
      margin-top: 0px;
    }
  }

  ::slotted(lilu-tooltip) {
    padding-left: 8px;
  }
}

.body {
  ::slotted(*) {
    display: block;
    margin-top: 8px;
  }
}

.arrow {
  display: flex;
  align-items: center;
}
